module.exports = __webpack_public_path__ + "img/Car_of_the_month_FR.148ca1d3.jpg";